import { useRef, useState } from 'react'

export const useTurnstile = () => {
  const turnstileRef = useRef(null)
  const [turnstileToken, setTurnstileToken] = useState(null)

  // Returns the token captured via the widget's onSuccess callback (Cloudflare's
  // canonical pattern), falling back to reading the widget response directly.
  // No more polling loop — the token is set reactively by onSuccess.
  const getTurnstileToken = () => {
    if (typeof window === 'undefined') return null
    return turnstileToken || turnstileRef.current?.getResponse() || null
  }

  // Clear the token and reset the widget so a fresh challenge can be solved
  // (Turnstile tokens are single-use and expire after 300s).
  const resetTurnstile = () => {
    setTurnstileToken(null)
    turnstileRef.current?.reset()
  }

  return {
    getTurnstileToken,
    resetTurnstile,
    turnstileRef,
    turnstileToken,
    setTurnstileToken,
  }
}
